export default __webpack_public_path__ + "static/media/companies-icon-tool.fbb80f2e.svg";